module.exports = __webpack_public_path__ + "1f63e82868e34a3575f480b15fda6b4d.pdf";